module.exports = __webpack_public_path__ + "img/ch3pic10.5ad75d15.png";